/**
 * Life Blueprint V2.9.9 — DB_LN authoritative slice (columns 11 & 12 only).
 *
 * ────────────────────────────────────────────────────────────────────────
 * AUTHORITY
 *   Workbook:  Life_Blueprint_V2_9_9_R2.xlsx
 *   SHA-256:   6d97148d708a3dbc84bcec9bdce9facdb815891de077036c9fc118a75e86d500
 *   Sheet:     DB_LN
 *   Used range:  A1:R10 (headers row 1, data rows 2..10)
 *   Scope of THIS module: rows 2..10 (life# 1..9) × columns 11 (K = 事业分)
 *                          and 12 (L = 财富分) ONLY.
 *   Evidence:  evidence/analysis-3b3a-dependency-closure.json
 *
 * NOT INCLUDED (deliberately, per user Q3 authorisation)
 *   Columns B..J (character/interpretation text), M..R (other numeric
 *   scores). These remain UNINGESTED. Do NOT reference them from any
 *   V2.9.9 runtime path.
 *
 * VLOOKUP CONTRACT (verbatim from six-index formulas)
 *   VLOOKUP( lifeNumber, DB_LN!A:L, 11 /* or 12 *\/, FALSE )
 *   - key type: integer 1..9
 *   - miss/IFERROR default: 65 (baked into each caller formula)
 *
 * ISOLATION
 *   Frozen JS object. No wall clock. No LLM. No mutation.
 * ────────────────────────────────────────────────────────────────────────
 */

export const DB_LN_SLICE_MODULE_VERSION = "DB_LN_SLICE.v1.0.0-task3b3a";
export const DB_LN_SLICE_WORKBOOK_SHA256 =
  "6d97148d708a3dbc84bcec9bdce9facdb815891de077036c9fc118a75e86d500";

/** Column K (事业分) header text (verbatim). */
export const DB_LN_COL_K_HEADER = "事业分";
/** Column L (财富分) header text (verbatim). */
export const DB_LN_COL_L_HEADER = "财富分";

/** IFERROR default baked into every VLOOKUP call in the six indices. */
export const DB_LN_VLOOKUP_FALLBACK = 65;

/**
 * Authoritative 9-row slice · WORKBOOK_CACHED_STATIC.
 * Row order = life# 1..9. Values verbatim from workbook.
 */
const DB_LN_CAREER_WEALTH = Object.freeze({
  1: Object.freeze({ K: 85, L: 80 }),
  2: Object.freeze({ K: 70, L: 68 }),
  3: Object.freeze({ K: 75, L: 72 }),
  4: Object.freeze({ K: 80, L: 75 }),
  5: Object.freeze({ K: 78, L: 80 }),
  6: Object.freeze({ K: 72, L: 70 }),
  7: Object.freeze({ K: 82, L: 75 }),
  8: Object.freeze({ K: 88, L: 92 }),
  9: Object.freeze({ K: 75, L: 70 }),
});
export { DB_LN_CAREER_WEALTH };

/**
 * VLOOKUP( lifeNumber, DB_LN!A:L, 11, FALSE )   →  DB_LN col K "事业分".
 * Returns integer for life# ∈ {1..9}; returns DB_LN_VLOOKUP_FALLBACK (65)
 * for any other integer key (mirrors Excel `IFERROR(VLOOKUP(...),65)`).
 */
export function dbLnLookupCol11(lifeNumber) {
  if (!Number.isInteger(lifeNumber)) return DB_LN_VLOOKUP_FALLBACK;
  const row = DB_LN_CAREER_WEALTH[lifeNumber];
  return row ? row.K : DB_LN_VLOOKUP_FALLBACK;
}

/**
 * VLOOKUP( lifeNumber, DB_LN!A:L, 12, FALSE )   →  DB_LN col L "财富分".
 * Same fallback semantics as `dbLnLookupCol11`.
 */
export function dbLnLookupCol12(lifeNumber) {
  if (!Number.isInteger(lifeNumber)) return DB_LN_VLOOKUP_FALLBACK;
  const row = DB_LN_CAREER_WEALTH[lifeNumber];
  return row ? row.L : DB_LN_VLOOKUP_FALLBACK;
}
